import {Restaurant, RestaurantProduct} from '../models/restaurant.model';

export const getPriceRange = (product: RestaurantProduct): number[] => {
  const prices: number[] = [];

  for (const variation of product.variations) {
    if (prices.indexOf(variation.price.formattedAmount) === -1) {
      prices.push(variation.price.formattedAmount);
    }
  }

  if (prices.length === 1 && prices[0] === 0) {
    let removedZero: boolean = false;
    for (const modifierGroup of product.modifierGroups) {
      if (modifierGroup.selectionType === 'SINGLE') {
        for (const modifier of modifierGroup.modifiers) {
          if (prices.indexOf(modifier.price.formattedAmount) === -1) {
            if (prices[0] === 0 && !removedZero) {
              prices.pop();
              removedZero = true;
            }
            prices.push(modifier.price.formattedAmount);
          }
        }
      }
    }
  }

  return prices.length === 1
    ? prices
    : [Math.min(...prices), Math.max(...prices)];
};

export const getPriceWithModifiers = (product: RestaurantProduct): number => {
  let prices: number = product.variations[0].price.amount;
  for (const modifierGroup of product.modifierGroups) {
    if (modifierGroup.selectionType === 'SINGLE') {
      prices += modifierGroup.modifiers[0].price.amount;
    } else {
      modifierGroup.modifiers.map(modifier => {
        if (modifier.onByDefault) {
          prices += modifier.price.amount;
        }
      });
    }
  }
  return prices / 100;
};

export const isShowDailyAvailabilityItem = (product: RestaurantProduct, restaurant: Restaurant): boolean => {
  if (restaurant?.hideItemsOutsideDailyAvailability) {
    const currentDate = new Date();
    const currentDay = currentDate.getDay();
    const currentTime = currentDate.getTime();

    return product.variations.some(variation => {
      if (variation.isDailyRestrictionEnabled) {
        return variation.dailyAvailability.some((availability: any) => {
          if (availability.value === currentDay && availability.enabled) {
            const startTime = new Date(availability.startTime).getTime();
            const endTime = new Date(availability.endTime).getTime();
            return currentTime >= startTime && currentTime <= endTime;
          }
          return false;
        });
      }
      return true;
    });
  }
  return true;
};

